import { render, staticRenderFns } from "./Invoicestatistics.vue?vue&type=template&id=471c0b7c&scoped=true&"
import script from "./Invoicestatistics.vue?vue&type=script&lang=js&"
export * from "./Invoicestatistics.vue?vue&type=script&lang=js&"
import style0 from "./Invoicestatistics.vue?vue&type=style&index=0&id=471c0b7c&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c0b7c",
  null
  
)

export default component.exports